import { render, staticRenderFns } from "./rms-objects-detail.vue?vue&type=template&id=304df9f2&scoped=true"
import script from "./rms-objects-detail.vue?vue&type=script&lang=js"
export * from "./rms-objects-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304df9f2",
  null
  
)

export default component.exports